import { ITurno } from "../models/turno";
import TurnoItem from "./turno-item";
import ReactPlayer from 'react-player';
import CarouselMedia from "./CarouselMedia";
import { useEffect, useState } from 'react';

interface IDivriPageProps {
  turnos: ITurno[];
  date: string;
  client: string;
  currentTurno?: ITurno | null;
}

const DivriPage = (props: IDivriPageProps): JSX.Element => {
  // Hooks siempre al inicio
  const [mediaList, setMediaList] = useState<{ url: string; type: 'image' | 'video' | 'youtube'; }[]>([
    { url: "https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/divri/DIGITURNO thumbnail_Imagen_pq.jpg", type: "image" },
    { url: "https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/divri/prueba-digiturno.mp4", type: "video" }
  ]);
  const [interval, setIntervalValue] = useState<number>(5000);
  const [containerBg, setContainerBg] = useState<string>('#e6f0ff');
  const [tableBg, setTableBg] = useState<string>('#3a5fc8');
  const [tableText, setTableText] = useState<string>('#ffffff');
  const [containerBorder, setContainerBorder] = useState<string>('#3a5fc8');
  const [imageBorder, setImageBorder] = useState<string>('#3a5fc8');
  const [enableAudio, setEnableAudio] = useState<boolean>(false);

  // Obtener el cliente actual
  const currentClient = (window as any).domain || 'Divri';
  const configKey = `carousel_config_${currentClient}`;

  useEffect(() => {
    try {
      const saved = localStorage.getItem(configKey);
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed.mediaList) && parsed.mediaList.length > 0) {
          setMediaList(parsed.mediaList);
        }
        if (typeof parsed.interval === 'number' && parsed.interval > 0) {
          setIntervalValue(parsed.interval);
        }
        if (typeof parsed.containerBg === 'string') {
          setContainerBg(parsed.containerBg);
        }
        if (typeof parsed.tableBg === 'string') {
          setTableBg(parsed.tableBg);
        }
        if (typeof parsed.tableText === 'string') {
          setTableText(parsed.tableText);
        }
        if (typeof parsed.containerBorder === 'string') {
          setContainerBorder(parsed.containerBorder);
        }
        if (typeof parsed.imageBorder === 'string') {
          setImageBorder(parsed.imageBorder);
        }
        if (typeof parsed.enableAudio === 'boolean') {
          setEnableAudio(parsed.enableAudio);
        }
      }
    } catch {}
  }, [configKey, currentClient]);

  if (props.client === "Divri") {
    return (
      <div className="divri2-container" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: containerBg,
        border: `2px solid ${containerBorder}`,
        borderRadius: 8,
        padding: 10,
        width: '100%',
        boxSizing: 'border-box',
        minHeight: '100vh',
        height: '100vh',
        position: 'relative'
      }}>
        {/* Carrusel de imágenes y videos */}
        <div style={{
          width: '98%',
          marginBottom: 10,
          border: `2px solid ${imageBorder}`,
          borderRadius: 6,
          overflow: 'hidden',
          height: '70vh',
          minHeight: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <CarouselMedia mediaList={mediaList} interval={interval} enableAudio={enableAudio} />
        </div>
        {/* Tabla de turnos */}
        <div style={{ width: '98%', flex: '0 0 30vh', maxHeight: '30vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
          <div style={{
            display: 'flex',
            background: tableBg,
            color: tableText,
            fontWeight: 'bold',
            fontSize: 20,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4
          }}>
            <div style={{ flex: 2, padding: 8, borderRight: '2px solid white', textAlign: 'center' }}>NOMBRE</div>
            <div style={{ flex: 1, padding: 8, borderRight: '2px solid white', textAlign: 'center' }}>TURNO</div>
            <div style={{ flex: 1, padding: 8, textAlign: 'center' }}>MÓDULO</div>
          </div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {props.turnos.map((turno) => (
              <div key={turno.id} style={{
                display: 'flex',
                background: '#f4f8ff',
                borderBottom: '1px solid #b3c6e6',
                fontSize: 18
              }}>
                <div style={{ flex: 2, padding: 8, borderRight: '1px solid #b3c6e6' }}>{turno.name}</div>
                <div style={{ flex: 1, padding: 8, borderRight: '1px solid #b3c6e6', textAlign: 'center' }}>{turno.turnoNumber}</div>
                <div style={{ flex: 1, padding: 8, textAlign: 'center' }}>{turno.moduleNumber}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='tv'>
      <div className='header'>
        <img
          src="https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/divri/thumbnail_Logo-DIVRI-.png"
          style={{
            height: '100px',
            margin: '10px'
          }}
        />
      </div>
      <div className='content'>
        {props.client === "Divri" && (
          <img 
            className='multimedia'
            src="https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/divri/DIGITURNO thumbnail_Imagen_pq.jpg"
          />
        )}
        <div className='items' style={props.client === "Divri" ? { paddingLeft: 70 } : {}}>
          {
            props.turnos.map((turno) => <TurnoItem key={turno.id} value={turno} />)
          }
        </div>
      </div>
      <div className='footer'>
        <div className='footer-table'>
          <div data-role="row">
            <div data-role="cell" className='time-cell'>
              {props.date.split('|')[1] || ''}
              <br />
              {props.date.split('|')[0] || ''}
            </div>
            <div data-role="cell" style={{ width: 'calc(100% - 120px)' }}>
              <div className='marquee'>
                <div className="marquee">
                  {<p style={{ paddingTop: '6px' }}> Síguenos a través de redes sociales como @divriveteranos o visita nuestro sitio web www.divri.gov.co #JuntosPorNuestrosVeteranos</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DivriPage; 